import { render, staticRenderFns } from "./StyledRadio.vue?vue&type=template&id=0fbd5716&scoped=true&"
import script from "./StyledRadio.vue?vue&type=script&lang=ts&"
export * from "./StyledRadio.vue?vue&type=script&lang=ts&"
import style0 from "./StyledRadio.vue?vue&type=style&index=0&id=0fbd5716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd5716",
  null
  
)

export default component.exports